import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import selectField from "@components/Fields/Select.Field.vue";
import { asRoundedPercentage } from "@components/Filters/number.js";
import { DomainDesignation } from "@constants";
import { centeredOffset, fullOffset } from "@utils/Directives/offset.js";
export default {
  components: {
    selectField
  },
  directives: {
    centeredOffset,
    fullOffset
  },
  filters: {
    asRoundedPercentage
  },
  props: {
    domain: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      programCategoryId: ""
    };
  },
  mounted() {},
  computed: {
    programOptions() {
      return this.$store.state.programCategories.slice().map(x => {
        return {
          text: x.Description,
          value: x.ProgramCategoryId
        };
      });
    },
    entityProgramCategories() {
      if (this.programCategoryId === "") return this.$store.state.entityProgramCategories.filter(x => x.CycleId === this.$store.state.cycleId);else return this.$store.state.entityProgramCategories.filter(x => x.CycleId === this.$store.state.cycleId && x.ProgramCategoryId === this.programCategoryId);
    },
    designationCounts() {
      let data = {};
      for (let key in DomainDesignation) {
        if (DomainDesignation[key].range) {
          let count = 0;
          count = this.entityProgramCategories.filter(x => x.Designation.label === DomainDesignation[key].label).length;
          data[DomainDesignation[key].label] = {
            config: DomainDesignation[key],
            count
          };
        }
      }
      return data;
    }
  },
  methods: {
    asPercentage(val) {
      return `${Math.round(val * 100)}%`;
    }
  }
};